export enum KnowledgeDbTab {
	PAIN_POINTS = "PAIN_POINTS",
	PRODUCTS_SERVICES = "PRODUCTS_SERVICES",
	CASE_STUDIES = "CASE_STUDIES",
	OBJECTION_HANDLING = "OBJECTION_HANDLING",
}

export const KNOWLEDGE_DB_TAB_LABELS: Record<KnowledgeDbTab, string> = {
	[KnowledgeDbTab.PAIN_POINTS]: "Pain Points & Value Propositions",
	[KnowledgeDbTab.PRODUCTS_SERVICES]: "Products & Services",
	[KnowledgeDbTab.CASE_STUDIES]: "Case Studies",
	[KnowledgeDbTab.OBJECTION_HANDLING]: "Objection Handling",
};

export enum ContentStatus {
	AI_DRAFTED = "AI_DRAFTED",
	HUMAN_APPROVED = "HUMAN_APPROVED",
	MANUAL = "MANUAL",
	DRAFT = "DRAFT",
}

/** Section names that can have individual content statuses */
export type SectionName =
	| "profile"
	| "painPoints"
	| "currentSolutions"
	| "marketTrends"
	| "obstacles"
	| "opportunities"
	| "featuresBenefits";

export const ALL_SECTION_NAMES: SectionName[] = [
	"profile",
	"painPoints",
	"currentSolutions",
	"marketTrends",
	"obstacles",
	"opportunities",
	"featuresBenefits",
];

export interface PersonaSegment {
	id: number;
	name: string;
}

export interface CompanySegment {
	id: number;
	name: string;
	personas: PersonaSegment[];
}

export interface PainPoint {
	id: number;
	title: string;
	obviousImpact: string;
	hiddenImpact: string;
}

export interface FeatureBenefitRow {
	id: number;
	feature: string;
	benefit: string;
	differentiation: string;
}

export type SectionContentStatuses = Partial<Record<SectionName, ContentStatus>>;

export interface SegmentContent {
	id: number;
	scorePersonaCategoryId: number;
	scoreCompanyCategoryId?: number | null;
	profile: string;
	painPoints: PainPoint[];
	currentSolutions: string;
	marketTrends: string;
	obstacles: string[];
	opportunities: string[];
	featuresBenefits: FeatureBenefitRow[];
	contentStatuses: SectionContentStatuses;
	companyId: number;
	createdAt: string;
	updatedAt: string;
}

/** Filter options for the segment sidebar */
export enum SegmentStatusFilter {
	ALL = "ALL",
	AI_DRAFTED = "AI_DRAFTED",
	APPROVED = "APPROVED",
}

export interface TabStatus {
	tab: KnowledgeDbTab;
	status: ContentStatus;
}

/** Key to uniquely identify a Company×Persona category */
export interface SegmentKey {
	scorePersonaCategoryId: number;
	scoreCompanyCategoryId: number;
}
